import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CurrentSiteService } from '../../shared/services/current-site.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class TitleResolver implements Resolve<any> {
    constructor(private readonly titleService: Title, private currentSiteService: CurrentSiteService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        return this.SiteName;
    }

    public get SiteName(): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.currentSiteService?.Site != null)
                resolve(this.currentSiteService.Site.name);
            else
                resolve(environment.sitename); //***Defaults to the app name if site info unavailable
        });
    }
}
